import * as API from "../../services/httpService"
import { navigate } from "gatsby"
import _ from "lodash"
import {
  pageIncrement,
  controlLoading,
  controlDeclaration,
  updateUiData,
} from "../../redux/actions"
import * as CommonFunction from "../../common/function"

const SubmitClaim = (dispatch, uiData, claimData) => {
  let submitData = _.cloneDeep(claimData)

  submitData.claimLiabilityDetail.claimAmount = CommonFunction.convertStringToDecimal(
    submitData.claimLiabilityDetail.claimAmount
  )

  submitData.claimLiabilityDetail.dateOfAccident = CommonFunction.combineDateAndTime(
    submitData.claimLiabilityDetail.dateOfAccident,
    submitData.claimLiabilityDetail.timeOfAccident
  )
  submitData.claimLiabilityDetail.noticeDate = CommonFunction.combineDateAndTime(
    submitData.claimLiabilityDetail.noticeDate,
    submitData.claimLiabilityDetail.noticeTime
  )

  if (submitData.claimLiabilityDetail.thirdPartyOccupation === "Others") {
    submitData.claimLiabilityDetail.thirdPartyOccupation =
      submitData.claimLiabilityDetail.thirdPartyOtherOccupation
  }

  submitData.claimLiabilityDetail.declaration = uiData.checkBoxStatus.isAgree

  // console.log(
  //   JSON.stringify({
  //   claimAttributeModel: submitData.claimAttributeModel,
  //   claimHeaderModel: submitData.claimLiabilityDetail,
  //   claimLiabilityDetail: submitData.claimLiabilityDetail,
  //   claimPayoutModel: submitData.claimPayoutModel,
  //   ClaimLiabilityWitnessListModel: submitData.claimLiabilityWitnessList,
  //   claimUploadListModel: uiData.claimUploadListModel,
  //   folderName: uiData.folderName,
  //   // sessionId: "",
  // })
  // )

  API.apiPostRequest(
    "/Claim/LiabilitySubmitClaim",
    {
      claimAttributeModel: submitData.claimAttributeModel,
      claimHeaderModel: submitData.claimLiabilityDetail,
      claimLiabilityDetailModel: submitData.claimLiabilityDetail,
      claimPayoutModel: submitData.claimPayoutModel,
      claimLiabilityWitnessListModel: submitData.claimLiabilityWitnessList,
      claimUploadListModel: uiData.claimUploadListModel,
      folderName: uiData.folderName,
      // sessionId: "",
    },
    null
  ).then(
    submitClaimResponse => {
      // console.log(submitClaimResponse)
      dispatch(controlDeclaration())
      dispatch(pageIncrement())
      dispatch(
        updateUiData(
          "submittedClaimID",
          submitClaimResponse.data.ClaimRequestNumber
        )
      )

      dispatch(controlLoading())
    },
    error => {
      navigate("errorOccurred")
    }
  )
}

export default SubmitClaim
